/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Voice_Manager_Unpin_Success_ToastInputs */

const en_voice_manager_unpin_success_toast = /** @type {(inputs: Voice_Manager_Unpin_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} un-pinned successfully`)
};

const fr_voice_manager_unpin_success_toast = /** @type {(inputs: Voice_Manager_Unpin_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} depingle avec succes`)
};

const de_voice_manager_unpin_success_toast = /** @type {(inputs: Voice_Manager_Unpin_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} wurde erfolgreich vom Fixierungspunkt getrennt.`)
};

const it_voice_manager_unpin_success_toast = /** @type {(inputs: Voice_Manager_Unpin_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} sbloccato con successo`)
};

const ru_voice_manager_unpin_success_toast = /** @type {(inputs: Voice_Manager_Unpin_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} успешно откреплен`)
};

const es_voice_manager_unpin_success_toast = /** @type {(inputs: Voice_Manager_Unpin_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} desanclado exitosamente`)
};

const zh_cn2_voice_manager_unpin_success_toast = /** @type {(inputs: Voice_Manager_Unpin_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} 已成功解除固定`)
};

const ja_voice_manager_unpin_success_toast = /** @type {(inputs: Voice_Manager_Unpin_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} のピン留めが正常に解除されました`)
};

const hi_voice_manager_unpin_success_toast = /** @type {(inputs: Voice_Manager_Unpin_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} सफलतापूर्वक अनपिन हो गया`)
};

const pt_pt2_voice_manager_unpin_success_toast = /** @type {(inputs: Voice_Manager_Unpin_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} desfixado com sucesso`)
};

/**
* | output |
* | --- |
* | "{name} un-pinned successfully" |
*
* @param {Voice_Manager_Unpin_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_unpin_success_toast = /** @type {((inputs: Voice_Manager_Unpin_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Unpin_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_unpin_success_toast(inputs)
	if (locale === "de") return de_voice_manager_unpin_success_toast(inputs)
	if (locale === "it") return it_voice_manager_unpin_success_toast(inputs)
	if (locale === "ru") return ru_voice_manager_unpin_success_toast(inputs)
	if (locale === "es") return es_voice_manager_unpin_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_unpin_success_toast(inputs)
	if (locale === "ja") return ja_voice_manager_unpin_success_toast(inputs)
	if (locale === "hi") return hi_voice_manager_unpin_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_unpin_success_toast(inputs)
	return en_voice_manager_unpin_success_toast(inputs)
});